import { render, staticRenderFns } from "./studentViewQuestion.vue?vue&type=template&id=72384f69&"
import script from "./studentViewQuestion.vue?vue&type=script&lang=js&"
export * from "./studentViewQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports